import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { instanceOf, arrayOf } from "prop-types";
import server from "glesys-controlpanel/models/server";
import privateNetwork from "glesys-controlpanel/models/private-network";
import { action } from "@ember/object";

@forbidExtraArgs
export default class NetworkAdapters extends Component {
  @arg(instanceOf(server)) server;
  @arg(arrayOf(instanceOf(privateNetwork))) privateNetworks;

  @action
  async loadData() {
    let networkAdapters = await this.server.networkAdapters;
    if (this.privateNetworks) {
      await Promise.all(this.privateNetworks.map((privateNetwork) => privateNetwork.segments));
    }
    return networkAdapters?.slice().sort((a, b) => a.name?.localeCompare(b.name));
  }

  getConnectedToLabel(networkAdapter) {
    if (networkAdapter?.network?.id?.startsWith("internet")) {
      return { type: "text", value: networkAdapter.network.description };
    }

    if (networkAdapter?.network?.id?.startsWith("vl")) {
      return { type: "link", value: networkAdapter.network.description, route: "networks" };
    }

    if (networkAdapter?.segment) {
      const privateNetworkId = networkAdapter.segment?.privateNetwork?.id;
      return {
        type: "link",
        value: networkAdapter.segment.name,
        route: "private-networks.details",
        model: privateNetworkId,
      };
    }

    return { type: "text", value: "Unknown" };
  }
}
